import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchFromOldApi } from '~/services/Http';

import { UnitPosition } from './types';

export type StoreState = {
  unitPositions: UnitPosition[];
  isLoading: boolean;
  failedToLoad: boolean;
  hasData: boolean;
};

const initialState: StoreState = {
  unitPositions: [],
  isLoading: false,
  failedToLoad: false,
  hasData: false,
};

export enum UnitPositionActionKeyPrefixes {
  FETCH_UNITPOSITIONS = 'unitPositions/FETCH_UNITPOSITIONS',
}

export type UnitPositionPayload = {
  unitPositions: UnitPosition[];
};

const getUnitPositions = async (): Promise<UnitPosition[]> =>
  await fetchFromOldApi(`/json/org/unitpositions`).then((r) => r.json());

export const fetchUnitPositions = createAsyncThunk<
  UnitPositionPayload,
  undefined
>(
  UnitPositionActionKeyPrefixes.FETCH_UNITPOSITIONS,
  async (): Promise<UnitPositionPayload> => {
    return {
      unitPositions: await getUnitPositions(),
    };
  },
);

export const unitPositionSlice = createSlice({
  name: '~/data/unitPositions',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchUnitPositions.fulfilled.type]: (
      state: StoreState,
      action: PayloadAction<UnitPositionPayload>,
    ) => {
      state.failedToLoad = false;
      state.isLoading = false;
      state.unitPositions = action.payload.unitPositions;
      state.hasData = true;
    },
    [fetchUnitPositions.pending.type]: (state: StoreState) => {
      state.isLoading = true;
    },
    [fetchUnitPositions.rejected.type]: (state: StoreState) => {
      state.failedToLoad = true;
    },
  },
});

export const unitPositionReducer = unitPositionSlice.reducer;
